import React, { useState, memo, useRef } from 'react'
import PropTypes from 'prop-types'
import Flex from 'Components/Flex'
import SvgIcon from 'Components/SvgIcon'

import {
  _Container, _Title,
  _ClearAllBtn, _SelectAllBtn,
  _SquareCheckBox, _SideSvg,
  _CollapsibleHead, _NeighbourhoodText,
  _Separator, _CloseContainer,
} from './styles'
import SortedAreaBoxList from '../SortedAreaBoxList'
import { isAreaSelectedChecker } from '../../utils'

const AreaCollapsible = (
  {
    calculateLcaAndSelectedAreas,
    defaultActiveState = false,
    currentArea,
    lcaMapTree,
    lastSearchObj,
    localLookups,
    onOutSideClick,
    childParentMap,
    googleAnalyticsEvent,
    showAllStyle,
    setHoveredDiscoveryArea = () => {},
    filterByViewPort,
    selectAllChildrenArea,
  }) => {
  const [collapsibleActive, updateCollapsibleActiveState] = useState(defaultActiveState)
  const areaChildrenSelected =
    !filterByViewPort && currentArea
      ? childParentMap[`${currentArea.areaType}_${currentArea.areaId}`]
      : null
  const areaChildrenSelectedLength = areaChildrenSelected && areaChildrenSelected.length
  const isAreaSelected = isAreaSelectedChecker(currentArea, lastSearchObj, localLookups) && !areaChildrenSelectedLength

  const containerRef = useRef()

  const highLightHead = isAreaSelected && !showAllStyle
  return (
    <_Container ref={containerRef}>
      <_CollapsibleHead
        onClick={() => {
          if(!showAllStyle) updateCollapsibleActiveState(!collapsibleActive)
          googleAnalyticsEvent({
            category: 'search',
            action: [
              'Discovery area collapsible ',
              collapsibleActive ? 'close' : 'open',
            ],
          })
        }}
        collapsibleActive={collapsibleActive}
        highLighted={highLightHead}
        // className={
        //   `${highLightHead ? css.highlightCollapsible : ''}`
        // }
        align={'center'}
        justify={'between'}
      >
        <Flex align={'center'}>
          {
            !showAllStyle && (
              <_SquareCheckBox
                data-test-id={'areaSliderSelectBox'}
                aria-label={`Click to select ${currentArea ? currentArea.label : ''}`}
                aria-pressed={isAreaSelected}
                selected={isAreaSelected}
                onClick={(e) => {
                  e.stopPropagation()
                  googleAnalyticsEvent({
                    category: 'search',
                    action: [
                      'Discovery area collapsible checkbox',
                      isAreaSelected ? 'deselect' : 'select',
                      currentArea.areaType,
                    ],
                  })
                  calculateLcaAndSelectedAreas(`${currentArea.areaType}_${currentArea.areaId}`, isAreaSelected)
                }}
              >
                {
                  isAreaSelected && (
                    <SvgIcon name="#icon-checkmark-final" width={24} height={24} />
                  )
                }
              </_SquareCheckBox>
            )
          }
          <Flex>
            <_Title>
              {currentArea ? currentArea.label : ''}
              {
                areaChildrenSelectedLength ? <_Separator>{' '}|</_Separator> : ''
              }
              {
                areaChildrenSelectedLength
                  ? ` ${areaChildrenSelectedLength} Selected Area${areaChildrenSelectedLength > 1 ? 's' : ''}`
                  : showAllStyle ? (
                    <_NeighbourhoodText>
                      Neighbourhoods
                    </_NeighbourhoodText>
                  ) : ''
              }

            </_Title>
            {
              showAllStyle && !areaChildrenSelected && (
                <_SelectAllBtn
                  onClick={() => {
                    if(!selectAllChildrenArea) return null
                    const { areaType } = currentArea
                    selectAllChildrenArea(`${areaType}_${currentArea.areaId}`)
                  }}
                  textClickableBtn
                >
                  Select all
                </_SelectAllBtn>
              )
            }
            {
              areaChildrenSelected && currentArea && (
                <_ClearAllBtn
                  onClick={() => {
                    calculateLcaAndSelectedAreas(`${currentArea.areaType}_${currentArea.areaId}`, false)
                  }}
                  textClickableBtn
                >
                  Clear
                </_ClearAllBtn>
              )
            }

          </Flex>
        </Flex>
        <_SideSvg>
          {
            showAllStyle
              ? (
                <_CloseContainer
                  aria-label="Close sub-area list"
                  data-test-id={'showAllCloseContainer'}
                  onClick={onOutSideClick}
                >
                  <SvgIcon name={'#icon-slim-close'} width={14} height={14} />
                </_CloseContainer>
              )
              : (
                <_CloseContainer>
                  <SvgIcon name={'#icon-arrow-final'} width={16} height={16} />
                </_CloseContainer>
              )
          }
        </_SideSvg>
      </_CollapsibleHead>
      {
        collapsibleActive && (
          <SortedAreaBoxList
            lcaMapTree={lcaMapTree}
            lastSearchObj={lastSearchObj}
            lookups={localLookups}
            rootArea={currentArea}
            showListActive={collapsibleActive}
            onHover={setHoveredDiscoveryArea}
            googleAnalyticsEvent={googleAnalyticsEvent}
            calculateLcaAndSelectedAreas={calculateLcaAndSelectedAreas}
          />
        )
      }
    </_Container>
  )
}
AreaCollapsible.propTypes = {

  currentArea: PropTypes.shape({
    areaType: PropTypes.string,
    areaId: PropTypes.number,
    label: PropTypes.string,
    filterType: PropTypes.string,
    children: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  localLookups: PropTypes.shape({
    id: PropTypes.number,
  }),
  childParentMap: PropTypes.shape({
    // Neighbourhood_29: Area
    [PropTypes.string]: PropTypes.shape({}),
  }),
  calculateLcaAndSelectedAreas: PropTypes.func,
  setHoveredDiscoveryArea: PropTypes.func,
  googleAnalyticsEvent: PropTypes.func,
  onOutSideClick: PropTypes.func,
  selectAllChildrenArea: PropTypes.func,
  defaultActiveState: PropTypes.bool,
  showAllStyle: PropTypes.bool,
  filterByViewPort: PropTypes.bool,
  lcaMapTree: PropTypes.shape({}),
  lastSearchObj: PropTypes.shape({}),
}

export default memo(AreaCollapsible)
